import { api } from 'data/api/api'

import { GetConversationsStatsResp } from '../types/unread-messages'

export const getConversationsStats = () =>
  api.get<GetConversationsStatsResp>('/conversations/stats')
